import React, { useState } from "react";

// import "./index.css";

import BackgroundVideo from "../../../video/about/bebop.mp4";
import BackgroundMobileImg from "../../../img/about/mobile/Mobile_IntroBackground-01.svg";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { useIsMobile } from "hooks/useDeviceType";
import { getLegacyFontStyles } from "../HomeStyles";
import { SerializedStyles, useTheme } from "@emotion/react";

export const Intro = () => {
  const isMobile = useIsMobile();
  const history = useNavigate();
  const [termsTicked] = useState(true);
  const theme = useTheme();
  const legacyFontStyles = getLegacyFontStyles(theme);
  const Title = getTitle(legacyFontStyles.primary);
  const Description = getDescription(legacyFontStyles.secondary);

  const handleClickLearnMore = () => {
    const sectionAElm = document.getElementById("feature-1");
    sectionAElm?.scrollIntoView({ behavior: "smooth" });
  };

  const connect = () => {
    if (termsTicked) {
      history("/trade");
    } else {
      // setModal("Connect_Modal");
    }
  };

  const background = isMobile ? (
    <MobileBackground alt="background" src={BackgroundMobileImg} />
  ) : (
    <Video autoPlay loop muted playsInline={true} controls={false}>
      <source src={BackgroundVideo} type="video/mp4" />
    </Video>
  );

  return (
    <Section>
      {background}
      <div className="row" style={{ position: "relative" }}>
        <div className="col-12">
          <Title>Make the most out of every exchange in DeFi</Title>
          <Description>
            Trade two or more tokens in one go, at the exact price you see, with no extra fees.
          </Description>
          <div className="d-flex flex-column flex-sm-row nowrap spacing">
            <button
              type="button"
              className="home-btn btn-bebop-green round me-sm-3 me-0"
              onClick={() => connect()}
            >
              Start trading
            </button>
            <button
              type="button"
              className="home-btn btn-bebop-outline dark round mt-3 mt-sm-0"
              onClick={handleClickLearnMore}
            >
              Learn more
            </button>
          </div>
        </div>
      </div>
    </Section>
  );
};

// Sub-components

const Section = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: start;
  color: white;
  position: relative;
  padding: 0 10%;
`;

const Video = styled.video`
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: -218px;
  z-index: 0;
`;

const MobileBackground = styled.img`
  width: 100vw;
  min-height: 90vh;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: -300px;
  z-index: 0;
`;

const getTitle = (fontStyle: SerializedStyles) => styled.h1`
  ${fontStyle}
  max-width: 805px;
  margin-bottom: 24px;
  font-weight: 300;
  font-size: calc(1.625rem + 4.5vw);
  line-height: 1.2;

  @media (min-width: 1200px) {
    font-size: 5rem;
  }

  @media screen and (min-width: 1920px) {
    font-size: 96px;
    max-width: 936px;
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    max-width: 547px;
  }

  @media screen and (min-width: 390px) and (max-width: 768px) {
    max-width: 547px;
  }

  @media screen and (max-width: 390px) {
    font-size: 32px;
    max-width: 272px;
  }
`;

const getDescription = (fontStyle: SerializedStyles) => styled.p`
  ${fontStyle}
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  color: #f3f3f3;
  max-width: 451px;
  margin-bottom: 40px;

  @media screen and (min-width: 1920px) {
    font-size: 36px;
    max-width: 612px;
  }

  @media screen and (min-width: 1280px) and (max-width: 1440px) {
    font-size: 20px;
  }

  @media screen and (min-width: 1024px) and (max-width: 1280px) {
    font-size: 20px;
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    font-size: 24px;
  }

  @media screen and (min-width: 390px) and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 390px) {
    font-size: 18px;
    max-width: 85%;
  }
`;
